<template>
  <div>
    <v-layout row wrap justify-end align-end>
      <download-excel
        class="v-btn v-btn--floating v-btn--small theme--dark primary"
        :data="payments"
        :fields="fields"
        name="cartera_pensiones.xls"
      >
        <v-icon color="white">cloud_download</v-icon>
      </download-excel>
    </v-layout>
    <v-card>
    <v-card-title>
      Pensiones
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="payments"
      :search="search"
      :loading="loading"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.siesa_receipt }}</td>
        <td class="text-xs-center">{{ props.item.siesa_payment }}</td>
        <td class="text-xs-center">{{ props.item.family }}</td>
        <td class="text-xs-center">{{ props.item.siesa_id }}</td>
        <td class="text-xs-center">{{ props.item.siesa_payer }}</td>
        <td class="text-xs-center">{{ props.item.suc }}</td>
        <td class="text-xs-center">{{ props.item.payment_date }}</td>
        <td class="text-xs-center">{{ props.item.traceability_code }}</td>
        <td class="text-xs-center">{{ props.item.payment_cicle }}</td>
        <td class="text-xs-center">{{ props.item.price }}</td>
        <td class="text-xs-center">{{ props.item.payment_method }}</td>
      </template>
    </v-data-table>
  </v-card>
  </div>
</template>

<script>
  import axios from 'axios'
  import JsonExcel from 'vue-json-excel'
  export default {
    name: 'enrollment-report-view',
    components: {
      'download-excel': JsonExcel,
    },
    data() {
      return {
        headers: [
          { text: this.$t('reports.headers.siesa_receipt'), align: 'center', value: 'siesa_receipt' },
          { text: this.$t('reports.headers.siesa_payment'), align: 'center', value: 'siesa_payment' },
          { text: this.$t('reports.headers.family'), align: 'center', value: 'family' },
          { text: this.$t('reports.headers.siesa_id'), align: 'center', value: 'siesa_id' },
          { text: this.$t('reports.headers.siesa_payer'), align: 'center', value: 'siesa_payer' },
          { text: this.$t('reports.headers.suc'), align: 'center', value: 'suc' },
          { text: this.$t('reports.headers.payment_date'), align: 'center', value: 'payment_date' },
          { text: this.$t('reports.headers.traceability_code'), align: 'center', value: 'traceability_code' },
          { text: this.$t('reports.headers.payment_cicle'), align: 'center', value: 'payment_cicle' },
          { text: this.$t('reports.headers.price'), align: 'center', value: 'price' },
          { text: this.$t('reports.headers.payment_method'), align: 'center', value: 'payment_method' },
        ],
        payments: [],
        loading: false,
        search: '',
        fields: {
          'Factura': 'siesa_receipt',
          'Pago': 'siesa_payment',
          'Tercero ID': 'siesa_id',
          'Tercero': 'siesa_payer',
          'Fecha pago': 'payment_date',
          'Ciclo': 'payment_cicle',
          'Valor': 'price',
          'Metodo pago': 'payment_method'
        }
      }
    },
    created () {
      this.getReportData();
    },
    methods: {
      getReportData() {
        this.loading = true
        axios.get('/api/pension/report/portfolio')
          .then(resp => {
            if (resp.status === 200) {
              this.payments = resp.data.data
            }
            this.loading = false
          })
          .catch(error => {
            this.loading = false
          })
      },
      formatNumber(number) {
        if(!number || typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
      getCicle(date) {
        if (date == '') {
          return ''
        }
        const parsed_date = new Date(Date.parse(date))
        const hour = parsed_date.getHours()
        const minutes = parsed_date.getMinutes()
        const minutes_total = (hour * 60) + minutes
        // ciclo 1 - 17:30 - 8:30 (1050 - 510)
        // ciclo 2 - 8:30 - 11:00 (510 - 660)
        // ciclo 3 - 11:00 - 13:30 (660 - 810)
        // ciclo 4 - 13:30 - 15:30 (810 - 930)
        // ciclo 5 - 15:30 - 17:30 (930 - 1050)
        let cicle = 0
        if (minutes_total >= 1050 || minutes_total < 510) {
          cicle = 1
        }
        if (minutes_total >= 510 && minutes_total < 660) {
          cicle = 2
        }
        if (minutes_total >= 660 && minutes_total < 810) {
          cicle = 3
        }
        if (minutes_total >= 810 && minutes_total < 930) {
          cicle = 4
        }
        if (minutes_total >= 930 && minutes_total < 1050) {
          cicle = 5
        }
        return `Ciclo ${cicle}`
      },
      formatDate(date) {
        let date_to_format = new Date(date)
        let formatted_date = date_to_format.getFullYear() + "-" + (date_to_format.getMonth() + 1) + "-" + date_to_format.getDate() + " " + date_to_format.getHours() + ":" + date_to_format.getMinutes() + ":" + date_to_format.getSeconds()
        return formatted_date
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/pension/portfolio.vue